export default __webpack_public_path__ + "c552a7b735b70250cb6e470c0fa306d3.png";